import { __module as t } from "./ghl-ui.es1704.js";
import { i as l } from "./ghl-ui.es1541.js";
import { t as v } from "./ghl-ui.es1631.js";
import { r as _ } from "./ghl-ui.es1637.js";
(function(o, r) {
  var a = l.default;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = u;
  var f = a(v), i = a(_), s = 864e5;
  function u(m) {
    (0, i.default)(1, arguments);
    var e = (0, f.default)(m), p = e.getTime();
    e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
    var d = e.getTime(), n = p - d;
    return Math.floor(n / s) + 1;
  }
  o.exports = r.default;
})(t, t.exports);
var C = t.exports;
export {
  C as g
};
